import { render } from "./WCLinkedItems.vue?vue&type=template&id=0801f582"
import script from "./WCLinkedItems.vue?vue&type=script&lang=js"
export * from "./WCLinkedItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__